import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "conditional-rules",
  "use": "conditional-rules-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"conditional-rules\"><path fill-rule=\"evenodd\" d=\"m20 14-2.29 2.29-2.88-2.88-1.42 1.42 2.88 2.88L14 20h6m0-10V4h-6l2.29 2.29-4.7 4.71H4v2h8.41l5.3-5.29\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol